import { Component, Input, OnInit, } from '@angular/core';
import SlotSecondPageModel from '../../models/slot-second-page.model';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { BundleDetailsModalService } from '../../services/bundle-details-modal.service';

@Component({
  selector: '[boho-side-order-details-slot]',
  templateUrl: './boho-side-order-details-slot.component.html',
})
export class BohoSideOrderDetailsSlotComponent implements OnInit {
  @Input() public slot: SlotSecondPageModel;

  public isDetailsLinkVisible: boolean = false;

  constructor(
    public commonInfo: CommonInfoService,
    private bundleDetailsModalService: BundleDetailsModalService
  ) {
  }

  ngOnInit() {
    this.isDetailsLinkVisible = this.slot.device?.bundledDevice;
  }

  public showDetails(event: Event) {
    event.preventDefault();

    const deviceId = this.slot.device.sku;

    const msisdn = this.slot.getMsisdn();

    this.bundleDetailsModalService.showDetailsModal(deviceId, msisdn);
  }
}
